import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		authentication: false,
		self: {
			id: null,
			name: null,
			accessToken: null,
			employeeId: null,
			userType: null
		}
	},

	actions: {
		login ({ commit }, { password, username }) {
			return window.axios.post('/users/authenticate', { 
				email: '', 
				password,
				username
			}).then((response) => {
				const self = {
					id: response.data.id,
					name: response.data.username,
					accessToken: response.data.token,
					employeeId: response.data.employeeId,
					userType: response.data.userType
				}
				const authentication = true;
				localStorage.setItem('self', JSON.stringify(self));
				localStorage.setItem('authentication', JSON.stringify(authentication));
				window.axios.defaults.headers.common.Authorization = response.data.token;
				
				commit(types.LOGIN, self);
				return response.data
			})
		},

		logout ({ commit }) {
			localStorage.removeItem('self');
			localStorage.removeItem('authentication');
			delete window.axios.defaults.headers.common.authentication;
			commit(types.LOGOUT)
		}
	},

	mutations: {
		[types.LOGIN] (state, self) {
			state.authentication = true;
			state.self.id = self.id;
			state.self.name = self.name;
			state.self.accessToken = self.accessToken
			state.self.employeeId = self.employeeId
			state.self.userType = self.userType
		},

		[types.LOGOUT] (state) {
			state.authentication = false;
			state.self.id = null;
			state.self.name = null;
			state.self.accessToken = null
			state.self.employeeId = null
			state.self.userType = null
		}
	},

	getters: {}
}
